import { render, staticRenderFns } from "./AdminConversations.vue?vue&type=template&id=53c958b9&scoped=true"
import script from "./AdminConversations.vue?vue&type=script&lang=js"
export * from "./AdminConversations.vue?vue&type=script&lang=js"
import style0 from "./AdminConversations.vue?vue&type=style&index=0&id=53c958b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c958b9",
  null
  
)

export default component.exports